import { render, staticRenderFns } from "./JobSearchPreviewDetail.vue?vue&type=template&id=0baaf002&scoped=true"
import script from "./JobSearchPreviewDetail.vue?vue&type=script&lang=js"
export * from "./JobSearchPreviewDetail.vue?vue&type=script&lang=js"
import style0 from "./JobSearchPreviewDetail.vue?vue&type=style&index=0&id=0baaf002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baaf002",
  null
  
)

export default component.exports